import { useContext } from "react";
import { MicrophoneContext } from "../providers";

const useMicrophone = () => {
  const microphoneContext = useContext(MicrophoneContext);

  if (!microphoneContext) {
    throw new Error("useMicrophone must be used within an MicrophoneProvider");
  }
  return microphoneContext;
};

export default useMicrophone;
